import { useMemo } from 'react';
import { OfferHeader } from '../../components/OfferHeader';
import { PriceDiscount } from '../../components/PriceDiscount';
import { useOfferContext } from '../OfferContext';
import { priceToString } from '../../utils/formatters/price';
import { NBSP } from '../../constants';
import { EIcons } from '../../types';

export function OfferHeaderContainer() {
  const { price: offerPrice, category, icons: offerIcons, isColorized, discount, author } = useOfferContext();

  const price = useMemo(() => {
    const formattedPrice = priceToString(offerPrice);

    return category.includes('daily') ? `от${NBSP}${formattedPrice}` : formattedPrice;
  }, [category, offerPrice]);

  const levelNumber = useMemo(() => {
    if (author?.qualityLevelInfo) {
      return 0;
    }

    return author?.trustInfo?.levelOrder || 0;
  }, [author]);

  const icons = useMemo(() => {
    let icons = offerIcons;

    if (levelNumber > 2 && !icons.includes(EIcons.FairPlay)) {
      icons = [...icons, EIcons.FairPlay];
    }

    return icons;
  }, [levelNumber, offerIcons]);

  const iconOptions = useMemo(() => ({ levelNumber }), [levelNumber]);

  const mainPrice = discount ? discount.newPrice : price;

  return (
    <OfferHeader
      price={mainPrice}
      discount={discount ? <PriceDiscount percent={discount.percent} oldPrice={price} /> : null}
      icons={icons}
      iconOptions={iconOptions}
      isHighlighted={isColorized}
    />
  );
}
